export default __webpack_public_path__ + "static/media/move-arte-2.4b365431.webp";